<template>
    <rkm-form
        v-if="model"
        ref="RkmFormDestino"
        show-legend
    >

        <rkm-area
            title="Identificação"
            type="section"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :validations="validations.descricaoDestino"
                        label="Descrição"
                        v-model="model.descricaoDestino"
                        type="text"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        :validations="validations.numeroDocumento"
                        label="Documento (CNPJ/CPF)"
                        v-model="model.numeroDocumento"
                        v-mask="documentoMask"
                        type="text"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group v-model="model.documentoTipoId">
                                    <rkm-form-radio :value="enums.documentoTipo.CNPJ">CNPJ</rkm-form-radio>
                                    <rkm-form-radio :value="enums.documentoTipo.CPF">CPF</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.observacao"
                        label="Observação"
                        v-model="model.observacao"
                        type="text"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="form.tiposDestino"
                        text-field="descricao"
                        value-field="id"
                        label="Tipo"
                        v-model="model.destinoTipoId"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.cnes"
                        label="CNES"
                        v-model="model.cnes"
                        number
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Logradouro"
            type="section"
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-select
                        :options="form.tiposLogradouro"
                        text-field="descricao"
                        value-field="id"
                        label="Tipo"
                        v-model="model.cadastroLogradouroTipoId"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.nomeLogradouro"
                        label="Nome"
                        v-model="model.nomeLogradouro"
                        type="text"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.numeroLogradouro"
                        label="Número"
                        v-model="model.numeroLogradouro"
                        type="number"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.nomeComplemento"
                        label="Complemento"
                        v-model="model.nomeComplemento"
                        type="text"
                        uppercase
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.nomeBairro"
                        label="Bairro"
                        v-model="model.nomeBairro"
                        type="text"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.numeroCep"
                        label="CEP"
                        v-model="model.numeroCep"
                        v-mask="this.mask.cep"
                        type="text"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-select
                        :options="form.estados"
                        :validations="validations.estado"
                        text-field="uf"
                        value-field="id"
                        label="UF"
                        v-model="model.estadoId"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input-autocomplete
                        :searchFields="autocompleteFields.municipio"
                        :repository="repositories.municipio"
                        :requestQueryStringParams="{ estado_id: model.estadoId }"
                        :validations="validations.municipio"
                        :disabled="!model.estadoId"
                        label="Município"
                        v-model="model.municipio"
                        uppercase
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Código IBGE"
                        type="text"
                        uppercase
                        disabled
                        v-model="model.numeroIbge"
                    />
                </rkm-col>

                <rkm-col cols="5">
                    <rkm-form-input
                        label="Telefone Comercial"
                        v-model="model.numeroTelefoneComercial"
                        :validations="validations.numeroTelefoneComercial"
                        type="text"
                        v-mask="numeroTelefoneComercialMask"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="5">
                    <rkm-form-input
                        label="Telefone Fax"
                        v-model="model.numeroTelefoneFax"
                        :validations="validations.numeroTelefoneFax"
                        v-mask="numeroTelefoneFaxMask"
                        type="text"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Informações complementares"
            type="section"
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-checkbox
                        :label="false"
                        v-model="model.bloqueado"
                        inline
                    >
                        Inativar
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-checkbox
                        :label="false"
                        v-model="model.tipoPrestador"
                        inline
                    >
                        Prestador de Serviço
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.distancia"
                        label="Distância (km)"
                        v-model="model.distancia"
                        type="number"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-form>
</template>

<script>

// Enums.
import documentoTipo from '@/enums/cadastro/documentoTipo'

// Mixins.
import { error, repository, stringCase, mask, unmask, object } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ cliente: 'getCliente' }),
        documentoMask() {
            return this.model.documentoTipoId === this.enums.documentoTipo.CNPJ ?
                this.mask.cnpj :
                this.mask.cpf
        },
        numeroTelefoneComercialMask() {

            if (this.model.numeroTelefoneComercial === '') {

                return ''
            }

            return this.model.numeroTelefoneComercial.length < 15 ? this.mask.phone : this.mask.cellPhone
        },
        numeroTelefoneFaxMask() {

            if (this.model.numeroTelefoneFax === '') {

                return ''
            }

            return this.model.numeroTelefoneFax.length < 15 ? this.mask.phone : this.mask.cellPhone
        },
        getDocumentoNumeroValidation() {
            const validation = {required: true}

            if (this.model.documentoTipoId == this.enums.documentoTipo.CPF) {

                validation.cpf = true
                validation.min_max_without_mask = 11
            } else if (this.model.documentoTipoId == this.enums.documentoTipo.CNPJ) {

                validation.cnpj = true
                validation.min_max_without_mask = 14
            }

            return validation
        },
        validations() {
            return {
                descricaoDestino: { required: true, max: 100, min: 3 },
                numeroDocumento: this.getDocumentoNumeroValidation,
                numeroCep: { min_max_without_mask: 8, },
                estado: { required: true },
                municipio: { required: true },
                numeroTelefoneComercial: { min_max_without_mask: [10, 11], },
                numeroTelefoneFax: { min_max_without_mask: [10, 11], },
                nomeLogradouro: { max: 50, },
                numeroLogradouro: { max: 5, },
                nomeComplemento: { max: 40, },
                nomeBairro: { max: 30, },
                observacao: { max: 200, },
                distancia: { max: 10, },
                cnes: {
                    required: false,
                    min: 7,
                    max: 7,
                },
            }
        },
    },
    created() {
        this.repositories.destino = this.getConectaSusRepository('transportePaciente.destino')
        this.repositories.municipio = this.getConectaSusRepository('intranet.municipio')

        this.load()
    },
    data: () => ({
        repositories: {
            destino: null,
            municipio: null,
        },
        form: null,
        autocompleteFields: {
            municipio: [
                {
                    key: 'nome',
                    searchable: true,
                },
            ],
        },
        estadoId: null,
        municipioId: null,
        model: null,
        enums: { documentoTipo },
    }),
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        limpaNumeroDocumento: () => this.model.numeroDocumento = '',
        convertBooleanToBinary: (valor) => valor ? 1 : 0,
        trataNull: (valor) => valor === undefined || valor == null ? null : valor,
        load() {
            this.setLoading()

            const request = this.id ?
                this.repositories.destino.edit(this.id) :
                this.repositories.destino.create()

            request
                .then(({ data }) => this.setData(data.form || null, data.model || null))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setData(form, model) {
            if (form) {

                this.form = Object.assign(form)
            }

            if (model) {

                this.model = Object.assign(model)
                this.model.bloqueado = this.model.bloqueado == 1
                this.model.tipoPrestador = this.model.tipoPrestador == 1
                this.estadoId = this.model.estadoId ?? null
            }
        },
        save() {
            this.$refs.RkmFormDestino.validate()
                .then(valid => {
                    if (valid) {
                        this.setLoading()

                        const modelSnakeCase = this.prepareData()

                        const request = modelSnakeCase.id === undefined || modelSnakeCase.id === null ?
                            this.repositories.destino.store(modelSnakeCase) :
                            this.repositories.destino.update(modelSnakeCase.id, modelSnakeCase)

                        request
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        prepareData() {
            const destino = this.clone(this.model)

            destino.id = this.trataNull(destino.id)

            destino.bloqueado = this.convertBooleanToBinary(destino.bloqueado)
            destino.tipoPrestador = this.convertBooleanToBinary(destino.tipoPrestador)

            if (destino.documentoTipoId === this.enums.documentoTipo.CNPJ && destino.numeroDocumento) {

                destino.numeroCnpj = this.unMaskCnpj(destino.numeroDocumento)
                destino.numeroCpf = null
            } else if (destino.documentoTipoId === this.enums.documentoTipo.CPF && destino.numeroDocumento) {

                destino.numeroCnpj = null
                destino.numeroCpf = this.unMaskCpf(destino.numeroDocumento)
            }

            destino.municipioId = destino.municipio ?
                destino.municipio.id :
                null

            destino.numeroCep = destino.numeroCep ?
                this.unMaskCep(destino.numeroCep) :
                null

            destino.numeroTelefoneComercial = destino.numeroTelefoneComercial ?
                this.unMaskPhone(destino.numeroTelefoneComercial) :
                null

            destino.numeroTelefoneFax = destino.numeroTelefoneFax ?
                this.unMaskPhone(destino.numeroTelefoneFax) :
                null

            delete(destino.municipio)
            delete(destino.numeroDocumento)
            delete(destino.numeroIbge)

            return this.camelObjectKeysToSnakeRecursive(destino)
        },
    },
    mixins: [ error, repository, stringCase, mask, unmask, object ],
    props: {
        id: { type: [Number], default: null }
    },
    watch: {
        'model.estadoId': function(estadoId) {

            if (estadoId !== this.estadoId) {

                this.model.estadoId = estadoId
                this.estadoId = estadoId

                this.model.municipio.id = ''
                this.model.municipio.nome = ''
                this.model.municipio.ibge = ''

                this.model.numeroIbge = ''
            }
        },
        'model.municipio': function(municipio) {

            if (municipio) {

                if (this.model.municipio.id !== this.municipioId) {

                    this.model.municipio = municipio
                    this.municipioId = municipio.id
                    this.model.numeroIbge = municipio.ibge
                }
            }
        }
    }
}
</script>